export default {
  props: {
    direction: {
      type: String,
      default: 'up',
    },
    customClass: {
      type: String,
      required: false,
      default: '',
    },
  },
  name: 'ArrowIcon',
  data() {
    return {
      className: 'app__arw__icon',
    };
  },
  computed: {
    pathClassName() {
      const customStyle = this.customClass ? `${this.customClass}__path` : '';
      return `${this.className}__path ${customStyle}`;
    },
    svgClassName() {
      return `${this.className} ${this.className}__${this.direction} ${this.customClass}`;
    },
  },
};
